import { render, staticRenderFns } from "./sms-icon.vue?vue&type=template&id=ea9dc104"
import script from "./sms-icon.vue?vue&type=script&lang=js"
export * from "./sms-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports